module.exports = __webpack_public_path__ + "static/media/map-image.ff2b3317.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map-image.jpg
// module id = 174
// module chunks = 0